//@ts-nocheck
import React from 'react'
import { Grid } from '@material-ui/core'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import MultiBackend, { createTransition, MouseTransition, TouchTransition } from 'react-dnd-multi-backend'
import Classifier from './Classifier'


export default function App() {
  const hasNative =
    document && (document.elementsFromPoint || document.msElementsFromPoint)

  function getDropTargetElementsAtPoint(x, y, dropTargets) {
    return dropTargets.filter(t => {
      const rect = t.getBoundingClientRect()
      return (
        x >= rect.left &&
        x <= rect.right &&
        y <= rect.bottom &&
        y >= rect.top
      )
    })
  }
  const MouseTransition = createTransition('keydown', (e) => {
    console.log(e)
    return e.type
      && e.key.indexOf('z') !== -1
      && e.type.indexOf('touch') === -1
  });
  const CustomHTML5toTouch = {
    backends: [
      {
        backend: HTML5Backend,
        // transition:
        // by default, will dispatch a duplicate `mousedown` event when this backend is activated
      },
      {
        backend: TouchBackend,
        // Note that you can call your backends with options
        options: { enableMouseEvents: true },
        preview: true,
        transition: MouseTransition,
        // will not dispatch a duplicate `touchstart` event when this backend is activated
        // skipDispatchOnTransition: true
      },



    ]
  };


// use custom function only if elementsFromPoint is not supported
  const options = {
    enableMouseEvents: true,
    preview: true
  }
  return (
<div>
  <DndProvider backend={MultiBackend} options={CustomHTML5toTouch}>

              <Classifier />
          </DndProvider>
</div>

  )
}
{/*<Grid container justify="center" spacing={2}>*/}
{/*  <DndProvider backend={HTML5Backend}>*/}
{/*    <Grid item xs={4} id={1}>*/}
{/*      <CADViewer />*/}
{/*    </Grid>*/}
{/*    <Grid item xs={4} id={2}>*/}
{/*      <Classifier />*/}
{/*    </Grid>*/}
{/*    <Grid item xs={4} id={3}>*/}
{/*      <CustomClassifier />*/}
{/*    </Grid>*/}
{/*  </DndProvider>*/}
{/*</Grid>*/}
